import { ActivityIndicator, Text } from "react-native-paper";
import { ScreenContainer } from "../../components";
import { useQuery } from "@apollo/client";
import { EVENT_DETAILS_QUERY } from "./EventDetailsScreen";
import { EventDetailsQuery, EventRegistrationQuery } from "./types";
import { TouchableOpacity, View } from "react-native";
import React from "react";
import LottieView from "lottie-react-native";
import { CURRENT_MEMBER_QUERY, EVENT_REGISTRATION_QUERY } from "./queries";
import BarcodeIcon from "../../svgs/BarcodeIcon";
import { ScreenProps } from "../types";

export default function EventConfirmationScreen({ navigation, route }: ScreenProps<"EventConfirmation">) {
  const { loading, data } = useQuery<EventDetailsQuery>(EVENT_DETAILS_QUERY, {
    variables: { slug: route.params.slug },
  });

  const { data: registrationData, loading: registrationLoading } = useQuery<EventRegistrationQuery>(EVENT_REGISTRATION_QUERY, {
    variables: { slug: route.params.slug },
  });

  const { data: memberData } = useQuery(CURRENT_MEMBER_QUERY);

  if (loading || registrationLoading) {
    return <ActivityIndicator className="flex-1 items-center justify-center" testID="query-loader" />;
  }

  if (!registrationData?.eventRegistration?.registeredAt) {
    navigation.navigate("EventDetails", { slug: route.params.slug });
  }

  return (
    <ScreenContainer>
      <View className="justify-center items-center py-6">
        <View className="w-28 h-28">
          <LottieView style={{ flex: 1 }} autoPlay source={require("../../../assets/lottie-icons/verified.json")} />
        </View>
        <Text className="text-title-2 font-700 mt-6">You're Registered!</Text>
        <Text className="text-regular-normal text-center mt-4 px-4">
          You have successfully pre-registered for the {data?.event?.title}. An email confirmation has been sent to{" "}
          <Text className="font-700">{memberData?.currentMember?.primaryEmail}.</Text>
        </Text>
      </View>
      {data?.event?.printablePass && (
        <View className="px-4" testID="printable-button">
          <TouchableOpacity
            onPress={() => navigation.navigate("EventTicket", { slug: route.params.slug })}
            className="flex flex-row rounded-lg mb-3 border-sky-dark border h-[188px] lg:h-[148px] self-center py-4 px-6 justify-center items-center"
          >
            <View className="mr-2 max-w-[80%]">
              <Text className="font-700 text-large-tight">Print Your Access Pass</Text>
              <Text className="text-small-normal mt-3">
                Bring your scannable Member Only Access Pass for convenient onsite check-in.
              </Text>
              <Text className="text-link-normal mt-3 text-ink-dark underline">Print It</Text>
            </View>
            <View className="flex-1 ml-4 lg:ml-10">
              <BarcodeIcon />
            </View>
          </TouchableOpacity>
        </View>
      )}
    </ScreenContainer>
  );
}
